import { idb } from "utils"
import { store } from "@redux"

import * as types from "../types/foods"

export const addFoods = (foods) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.saveItemsToDatabase(
    branchId,
    "foods",
    foods
  )

  return {
    type: types.ADD_FOODS,
    foods
  }
}

export const updateFoods = foods => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.saveItemsToDatabase(
    branchId,
    "foods",
    foods
  )

  return {
    type: types.UPDATE_FOODS,
    foods
  }
}

export const deleteFoods = (foods) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  const foodIds = foods.map(food => food._id)

  idb.deleteItemsFromDatabase(
    branchId,
    "foods",
    foodIds
  )

  return {
    type: types.DELETE_FOODS,
    foodIds
  }
}

export const clearFoods = () => ({
  type: types.CLEAR_FOODS
})